import { Box, Typography } from '@mui/material'
import { footerLinksStyles } from 'src/view/layout/Footer'

const EditorialPolicy = () => {
  return (
    <Box sx={footerLinksStyles.container}>
      <Typography variant="h3" sx={footerLinksStyles.heading}>
        Editorial Policy
      </Typography>

      <Typography sx={footerLinksStyles.effectiveDate}>Effective date: March 2, 2026</Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Proxio's goal is to provide accurate, timely, and unbiased reporting grounded in reputable sources. This policy
        explains how we source, publish, and correct our content.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        1) What we publish
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Proxio publishes agency-originated news reporting and updates. We may add brief, factual context (such as
        definitions, background timelines, or geographic context) to support reader understanding.
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Proxio does not publish opinion pieces. We do not publish endorsements, political viewpoints, or "hot take"
        commentary.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        2) Sourcing standards
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Proxio's reporting originates from the world's leading news agencies and other reputable primary sources. We
        prioritize sources with strong editorial standards and a demonstrated record of accuracy.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        3) Editorial independence
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Proxio's editorial decisions are independent of commercial influence. Proxio does not run advertising on
        proxio.media.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        4) Accuracy and updates
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Breaking news evolves quickly. When we publish developing stories:
      </Typography>

      <ul>
        <li>We aim to clearly distinguish confirmed facts from early or incomplete information</li>
        <li>We update stories as new verified information becomes available</li>
      </ul>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        5) Corrections policy
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Accuracy is a core value. If we publish an error, we correct it promptly.
      </Typography>

      <Typography variant="h5" sx={footerLinksStyles.subheading}>
        To request a correction:
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>Email contact@proxio.media and include:</Typography>

      <ul>
        <li>The URL (or headline) of the content</li>
        <li>What you believe is incorrect</li>
        <li>Supporting evidence or a reference source (if available)</li>
      </ul>

      <Typography variant="h5" sx={footerLinksStyles.subheading}>
        How corrections are handled:
      </Typography>

      <ul>
        <li>If a correction is warranted, we update the content as quickly as possible</li>
        <li>
          When a change is material (meaning it affects the understanding of the facts), we add a clear Correction note
          to the article describing what changed
        </li>
        <li>Minor edits (typos, formatting) may be made without a correction note unless they alter meaning</li>
      </ul>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        6) Use of AI and automation
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        Proxio may use automated tools to support publishing operations—such as formatting, categorization, translation
        assistance, summarization, and quality checks.
      </Typography>

      <Typography variant="h5" sx={footerLinksStyles.subheading}>
        Guardrails:
      </Typography>

      <ul>
        <li>We do not use AI to fabricate facts, quotes, or sources</li>
        <li>
          Any summaries or structured formats must be grounded in agency-originated reporting or other verified sources
        </li>
        <li>We monitor and refine automation to reduce errors and maintain clarity</li>
      </ul>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        7) Transparency and feedback
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        We welcome reader feedback and take correction requests seriously.
      </Typography>

      <Typography sx={footerLinksStyles.paragraph}>
        <strong>Contact:</strong> contact@proxio.media
      </Typography>
    </Box>
  )
}

export default EditorialPolicy
